import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class IdeasTableCellSourceComponent extends Component {
  @service betaToggle;

  get idea() {
    return this.args.idea;
  }

  @action
  handleSourceChange(idea, source) {
    idea.source = source.value;
    idea.save();
  }

  @action
  handleClearSource(idea) {
    idea.source = undefined;
    idea.save();
  }
}
